import axios from 'axios';
import { getProject } from '../gcloud/getProject';

/**
 * Create a Stripe PaymentIntent for processing payments
 * @param {number} amount - The payment amount (will be converted to cents)
 * @param {number} level - Payment level (1 for initial, 2 for final)
 * @param {string} formId - The form ID
 * @param {string} userId - The user ID
 * @param {string} email - The user's email
 * @returns {Promise} - Returns { status, clientSecret, paymentIntentId }
 */
const createPaymentIntent = async (amount, level, formId, userId, email) => {
  try {
    const url = `${getProject()}/createPaymentIntentV2`;
    
    console.log('Creating payment intent:', { amount, level, formId, userId, email });
    
    const response = await axios.post(url, {
      amount: parseFloat(amount),
      currency: 'usd',
      level: parseInt(level),
      formId,
      userId,
      email
    });

    if (response.data.status !== 'success') {
      throw new Error(response.data.message || 'Failed to create payment intent');
    }

    console.log('Payment intent created successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to create payment intent:', error);
    throw new Error(error.response?.data?.message || 'Failed to initialize payment. Please try again.');
  }
};

export default createPaymentIntent;
